<template>
  <footer>
    <div class="container">
      <div class="f-top flex_tablet__jcsb">
        <div class="f-nav flex_tablet__jcsb">
          <div class="nav-item">
            <div class="tit">快捷导航</div>
            <dl>
              <dd v-for="(k, i) in menus" :key="i">
                <a
                  @click="goToPage(k.outLink)"
                  v-if="k.outLink && k.outLink.indexOf('http') == -1"
                  >{{ k.name }}</a
                >
                <a
                  :href="
                    k.outLink ? k.outLink : 'javascript:alert(`建设中...`)'
                  "
                  :target="k.outLink ? '_blank' : ''"
                  v-else
                  >{{ k.name }}</a
                >
              </dd>
            </dl>
          </div>
          <div class="nav-item">
            <div class="tit">合作联系</div>
            <dl>
              <dd><a @click="goToPage('/cooperationContact')">渠道合作</a></dd>
              <dd><a @click="goToPage('/cooperationContact')">联系我们</a></dd>
            </dl>
          </div>
          <div class="nav-item">
            <div class="tit">帮助中心</div>
            <dl>
              <dd><a @click="goToPage('/beginnerGuide')">新手指南</a></dd>
              <dd><a @click="goToPage('/FAQ')">常见问题</a></dd>
              <dd v-for="i in helps" :key="i.id"><a @click="goToPage('/singlePage',query={id:i.id})">{{i.title}}</a></dd>
            </dl>
          </div>
        </div>
        <div class="f-contact flex_table__jcsb">
          <div class="info">
            <div class="tit">联系我们</div>
            <dl>
              <dt>全国统一服务热线</dt>
              <dd>
                <a :href="'tel:' + info.attr01">{{ info.attr01 }}</a>
              </dd>
            </dl>
            <dl>
              <dt>服务邮箱</dt>
              <dd>
                <a :href="'mailto:' + info.attr02">{{ info.attr02 }}</a>
              </dd>
            </dl>
          </div>
          <div class="code">
            <img :src="info.picUrl?info.picUrl:$noPic" alt="扫码关注公众号" />
            <p>扫码关注公众号</p>
          </div>
        </div>
      </div>
      <div class="f-bottom flex_tablet__jcsb">
        <div class="left" v-html="info.memo"></div>
        <div class="right">
          <a @click="goToPage('/singlePage',query={id:'1965252709624741889'})">法律声明</a>
          <a @click="goToPage('/singlePage',query={id:'1965255305466904577'})">网站地图</a>
          <a>流量统计</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      info: "",
      menus: [],
      helps: [],
    };
  },
  methods: {
    
  },
  beforeCreate() {},
  created() {},
};
</script>